// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlatformWebhooks_RetryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /platform-webhooks/retry — deliver one failed/dead delivery again, now. */
import { registerContract } from './validate'

export interface PlatformWebhooks_RetryInput {
delivery_id: number
}

registerContract('PlatformWebhooks_RetryInput', {
  delivery_id: { type: 'number',  required: true },
})
